'use client';

import { setToastCopy } from '@/components/ui/cultiv-toast';
import { AuthProvider } from '@/contexts/auth-context';
import { migrateAvmCookiesToLocalStorage } from '@/utils/avm-local-storage';
import { NextIntlClientProvider } from 'next-intl';
import { SWRConfig } from 'swr';

// Clean up legacy per-lead cookies on every page load to prevent 413 errors.
// Idempotent — only does real work once per browser, then becomes a flag check.
migrateAvmCookiesToLocalStorage();

export function Providers({
  children,
  locale,
  messages,
}: {
  children: React.ReactNode;
  locale: string;
  messages: any;
}) {
  // The toast card renders outside this provider (its <Toaster> is in the root
  // layout), so hand it the localised close label rather than a hook.
  setToastCopy({ close: messages?.common?.close });

  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <SWRConfig 
        value={{
          dedupingInterval: 5000,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          errorRetryCount: 2,
        }}
      >
        {/* No session probe: this provider wraps the public pages too, and asking who
            an anonymous visitor is answers 401 on every one of them. The probing
            provider is mounted by the `(crm)` layout — see components/CrmSessionProvider. */}
        <AuthProvider>
          {children}
        </AuthProvider>
      </SWRConfig>
    </NextIntlClientProvider>
  );
}